<div [class.show]="showPreloader()" class="page-preloader">
    <div class="loader-image"></div>
</div>

<div *ngIf="_exhibition" class="container">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb single-exhibition-breadcrumb">
            <li *ngIf="breadcrumbRootsTitle" class="breadcrumb-item">
                <a [routerLink]="urlService.link('exhibitions')">{{  breadcrumbRootsTitle[urlService.lang]  }}</a>
            </li>
            <li aria-current="page" class="breadcrumb-item active">{{  _exhibition.name[urlService.langCode]  }}</li>
        </ol>
    </nav>
</div>

<!-- blocks: before -->
<app-blocks-wrapper context="exhibition" placement="before"></app-blocks-wrapper>

<div *ngIf="_exhibition" class="container">
    <div class="row exhibition-row">
        <header class="page-header col-12 col-xl-6 order-lg-1 d-xl-none">
            <small class="header-small-tex exhibition-label styled-header">{{
                (_exhibition.status != 'exhibition_status_completed'
                        ? ('exhibitions.current-exhibition' | translate:urlService.lang)
                        : archiveExhibition[urlService.lang]
                ) | uppercase
                }}</small>

            <div [innerHTML]="_exhibition.name[urlService.langCode] | keepHtml"
                 class="page-title exhibition-title"></div>

            <p *ngIf="_exhibition.date_from && _exhibition.date_to" class="exhibition-time">
                <span *ngIf="_exhibition.date_from">{{ _exhibition.date_from | localizedDate:'dd.MM.yyyy' }}</span>
                <span *ngIf="_exhibition.date_to"> &ndash; {{ _exhibition.date_to | localizedDate:'dd.MM.yyyy' }}</span>
            </p>
        </header>

        <div class="col-12 col-lg-6 order-2 order-lg-2 exhibition-presentation-text">
            <!-- duplikacja, niestety -->
            <div class="page-header d-none d-xl-block">
                <small class="header-small-tex exhibition-label styled-header">{{
                    (_exhibition.status != 'exhibition_status_completed'
                            ? ('exhibitions.current-exhibition' | translate:urlService.lang)
                            : archiveExhibition[urlService.lang]
                    ) | uppercase
                    }}</small>

                <div [innerHTML]="_exhibition.name[urlService.langCode] | keepHtml"
                     class="page-title exhibition-title"></div>

                <p *ngIf="_exhibition.date_from && _exhibition.date_to" class="exhibition-time">
                    <span *ngIf="_exhibition.date_from">{{ _exhibition.date_from | localizedDate:'dd.MM.yyyy' }}</span>
                    <span
                        *ngIf="_exhibition.date_to"> &ndash; {{ _exhibition.date_to | localizedDate:'dd.MM.yyyy' }}</span>
                </p>
            </div>

            <div [innerHTML]="description()"></div>
            <div class="show-more-button-wrapper">
                <a (click)="toggleDescription()" *ngIf="cutDescription"
                   class="show-more-button">{{getExpandText[urlService.lang]}}</a>
            </div>
        </div>

        <div class="col-12 col-lg-6 order-1 order-lg-3 exhibition-presentation-materials">
            <ng-container *ngIf="_exhibition.sanitized_banner.type === 'html'">
                <div [innerHTML]="_exhibition.sanitized_banner.content"></div>
            </ng-container>

            <ng-container *ngIf="_exhibition.sanitized_banner.type === 'embed'">
                <div class="embed-responsive embed-responsive-16by9">
                    <iframe [src]="_exhibition.sanitized_banner.content[urlService.langCode] | youtubeEmbedUrl"
                            allowfullscreen=""
                            class="embed-responsive-item"></iframe>
                </div>
            </ng-container>

            <ng-container *ngIf="_exhibition.sanitized_banner.type === 'image'">
                <app-images-presentation #presentation *ngIf="_exhibition.images?.length"
                                         [images]="_exhibition.images"></app-images-presentation>

                <app-images-presentation #presentation *ngIf="!_exhibition.images?.length && _exhibition.image"
                                         [images]="[_exhibition.image]"
                                         [options]="{}" [owlMainClasses]="['owl-main-class']"></app-images-presentation>
            </ng-container>

            <div *ngIf="_exhibition.sanitized_banner.type === 'empty'" class="art-presentation-outer no-thumbs">
                <img alt="{{ _exhibition.name[urlService.langCode] }}" appLazyLoad class="img-fluid"
                     src="assets/images/placeholder-600x450.jpg"/>
            </div>

            <div class="row justify-content-end">
                <div class="col-12">
                    <div class="socials-share exhibition-aside-socials-share">

                        <app-social-share #socialShare (emailClick)="openRecommendationModal()"></app-social-share>

                    </div>
                </div>
            </div>

            <div class="row object-related">
                <div *ngIf="_exhibition.artists?.length" class="col-10 col-md-8 col-lg-12 col-xl-9">
                    <div
                        class="content-section-subheader">{{ 'exhibitions.related-artists' | translate:urlService.lang }}</div>

                    <ul class="object-related-list related-artists">
                        <li *ngFor="let artist of _exhibition.artists | artistsAZ" class="related-list-item">

                            <ng-container *ngIf="artist.type !== 'artists_type_invisible'">
                                <a [routerLink]="[urlService.link('artists', artist)]" class="related-item-link"
                                   target="_blank"> <span
                                    [innerHTML]="artist | artistName : urlService.langCode"></span><span
                                    *ngIf="globalService.settings.offer.display_artist_dates">&nbsp;</span><span
                                    [innerHTML]="artist | artistDates:urlService.lang"></span></a>
                            </ng-container>

                            <ng-container *ngIf="artist.type === 'artists_type_invisible'">
                                <span class="related-item-link"> <span
                                    [innerHTML]="artist | artistName : urlService.langCode"></span><span
                                    *ngIf="globalService.settings.offer.display_artist_dates">&nbsp;</span><span
                                    [innerHTML]="artist | artistDates:urlService.lang"></span></span>
                            </ng-container>

                        </li>
                    </ul>
                </div>

                <div *ngIf="_exhibition.attachments && _exhibition.attachments?.length"
                     class="col-10 col-md-8 col-lg-12 col-xl-9">
                    <div
                        class="content-section-subheader">{{ 'exhibitions.download' | translate:urlService.lang }}</div>

                    <ul class="object-related-list related-materials">
                        <li *ngFor="let attachment of _exhibition.attachments" class="related-list-item">
                            <a [innerHTML]="attachment.name[urlService.langCode]" class="related-item-link"
                               href="{{ attachment.url }}"
                               target="_blank"></a>
                        </li>
                    </ul>
                </div>

                <div *ngIf="_events && _events?.length" class="col-10 col-md-8 col-lg-12 col-xl-9">
                    <div
                        class="content-section-subheader">{{ 'exhibitions.related-posts' | translate:urlService.lang }}</div>

                    <ul class="list-unstyled object-related-list related-events">
                        <li *ngFor="let event of _events" class="media">
                            <div class="text-center">
                                <a [routerLink]="[urlService.link('events', event)]"
                                   class="related-object-image-link mr-3" target="_blank">
                                    <span
                                        [ngStyle]="{'background-image': 'url('+(event.banner && event.banner.thumbnails.miniature ? event.banner.thumbnails.miniature.url : 'assets/images/placeholder-70x44.jpg')+')'}"
                                        class="related-object-link-bg"></span>
                                </a>
                            </div>

                            <div class="media-body">
                                <div class="related-object-name mt-0 mb-1">
                                    <a [innerHTML]="event.name[urlService.langCode]"
                                       [routerLink]="[urlService.link('events', event)]"
                                       class="related-object-link" target="_blank"></a></div>

                                <p *ngIf="event.date_from">
                                    <span
                                        *ngIf="event.date_from">{{ event.date_from | localizedDate:'dd.MM.yyyy' }}</span>
                                    <span
                                        *ngIf="event.date_to"> &ndash; {{ event.date_to | localizedDate:'dd.MM.yyyy' }}</span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <app-modal-form #recommendationModal *ngIf="_exhibition" [object]="_exhibition"
                    [options]="{type:'recommend', what:'exhibition'}"></app-modal-form>

    <section *ngIf="_works && _works?.length" class="exhibition-content-section">
        <div
            class="section-title styled-header catalogue-label">{{ 'exhibitions.catalogue' | translate:urlService.lang }}
            - <span
                class="catalogue-count">{{ _worksPagination.allRecords }}</span></div>

        <div class="row">
            <div class="col-12">

                <div *ngIf="isMasonry === 'true'; else elseBlock">

                    <ngx-masonry #masonry
                                 [options]="{horizontalOrder:true, itemSelector:'.masonry-grid-item', columnWidth:'.grid-sizer', percentPosition:true}"
                                 [useImagesLoaded]="false"
                                 class="masonry-grid">
                        <ngxMasonryItem *ngFor="let work of _works; let index = index" [class.grid-sizer]="index === 0"
                                        [ngClass]="{'no-zoom': !zoomImages}" class="masonry-grid-item">

                            <div class="grid-item-inner">
                                <article class="masonry-grid-item-article">
                                    <a [routerLink]="[urlService.link('products', work)]"
                                       [queryParams]="{exhibition_id: _exhibition.id, ex_id: id}"
                                       class="masonry-grid-item-link">
                                        <div class="grid-item-figure offer icon-with-custom-padding">

                                            <img *ngIf="work.images?.length" alt="{{ work.name[urlService.langCode] }}"
                                                 appLazyLoad
                                                 class="img-fluid"
                                                 src="{{ work.images[0]?.thumbnails?.slideshow.url ? work.images[0]?.thumbnails?.slideshow.url : work.images[0]?.thumbnails?.original.url }}"/>

                                            <img *ngIf="!work.images?.length" alt="{{ work.name[urlService.langCode] }}"
                                                 appLazyLoad
                                                 class="img-fluid" src="assets/images/placeholder-450x340.jpg"/>

                                        </div>

                                        <div class="grid-item-content">
                                            <small class="exhibition-catalogue-id">{{ work.sortKey }}</small>

                                            <div *ngIf="work.artists?.length" class="grid-item-title artist-name">

                                                <ng-container
                                                    *ngFor="let artist of work.artists | artistsAZ; let indexA = index">
                                                    <span
                                                        [innerHTML]="artist | artistName: urlService.langCode:'asHtml'"></span>
                                                    <span *ngIf="indexA < (work.artists?.length - 1)">,<br/></span>
                                                </ng-container>

                                            </div>

                                            <p class="grid-item-text offer-title">
                                                <span
                                                    [ngClass]="{'with-underline':activeTextElementsOnHoverEnabled, 'hoverable-element':true}"
                                                    class="title">{{ work.name[urlService.langCode] }}</span><span
                                                *ngIf="work.year || work.year_to || work.year_text[urlService.langCode]"
                                                class="work-date">,
                                                {{ work | workDates:urlService.langCode }}</span>
                                                <br/>
                                                <ng-container
                                                    *ngIf="work.medium && work.medium[urlService.langCode]">{{ work.medium[urlService.langCode] }}
                                                    <br/></ng-container>

                                            </p>
                                            <p [innerHTML]="work | workDimensions:urlService.lang:true"
                                               class="work-dimensions in-exhibition-preview"></p>
                                            <ng-container *ngIf="work.availability !== 'object_availabilty_available'">
                                                <p class="masonry-grid-item-info statusOnOfferList">
                                                    {{ 'offer.sold' | translate:urlService.lang }}
                                                </p>
                                            </ng-container>
                                            <p *ngIf="globalService.settings.offer.show_prices && work.availability === 'object_availabilty_available'"
                                               class="masonry-grid-item-info">{{ 'offer.price' | translate:urlService.lang }}
                                                : <span
                                                    [innerHTML]="work | workPrice:'exhibition_item:price':_exhibition.retail_price_currency"></span>
                                            </p>
                                        </div>
                                    </a>
                                </article>
                            </div>

                        </ngxMasonryItem>
                    </ngx-masonry>

                </div>

                <ng-template #elseBlock>
                    <div class="no-masonry">
                        <div *ngFor="let work of _works; let index = index"
                             [ngClass]="{'no-zoom': !zoomImages, 'four-columns': isFourColumns === 'true', 'three-columns': isFourColumns !== 'true'}"
                             class="masonry-grid-item grid-sizer">

                            <div class="grid-item-inner">
                                <article class="masonry-grid-item-article">
                                    <a [routerLink]="[urlService.link('products', work)]"
                                       [queryParams]="{exhibition_id: _exhibition.id, ex_id: id}"
                                       class="masonry-grid-item-link">
                                        <div class="grid-item-figure offer icon-with-custom-padding">
                                            <img *ngIf="work.images?.length" alt="{{ work.name[urlService.langCode] }}"
                                                 appLazyLoad
                                                 class="img-fluid"
                                                 src="{{ work.images[0]?.thumbnails?.slideshow.url ? work.images[0]?.thumbnails?.slideshow.url : work.images[0]?.thumbnails?.original.url }}"/>

                                            <img *ngIf="!work.images?.length" alt="{{ work.name[urlService.langCode] }}"
                                                 appLazyLoad
                                                 class="img-fluid" src="assets/images/placeholder-450x340.jpg"/>

                                        </div>

                                        <div class="grid-item-content">
                                            <small class="exhibition-catalogue-id">{{ work.sortKey }}</small>

                                            <div *ngIf="work.artists?.length" class="grid-item-title artist-name">

                                                <ng-container
                                                    *ngFor="let artist of work.artists | artistsAZ; let indexA = index">
                                                    <span
                                                        [innerHTML]="artist | artistName: urlService.langCode:'asHtml'"></span>
                                                    <span *ngIf="indexA < (work.artists?.length - 1)">,<br/></span>
                                                </ng-container>

                                            </div>

                                            <p class="grid-item-text offer-title">
                                                <span
                                                    [ngClass]="{'with-underline':activeTextElementsOnHoverEnabled, 'hoverable-element':true}"
                                                    class="title">{{ work.name[urlService.langCode] }}</span><span
                                                *ngIf="work.year || work.year_to || work.year_text[urlService.langCode]"
                                                class="work-date">,
                                                {{ work | workDates:urlService.langCode }}</span>
                                                <br/>
                                                <ng-container
                                                    *ngIf="work.medium && work.medium[urlService.langCode]">{{ work.medium[urlService.langCode] }}
                                                    <br/></ng-container>

                                            </p>

                                            <p [innerHTML]="work | workDimensions:urlService.lang:true"
                                               class="work-dimensions in-exhibition-preview"></p>


                                            <ng-container [ngSwitch]="work.availability">
                                                <ng-container *ngSwitchCase="'object_availabilty_available'">
                                                    <p *ngIf="globalService.settings.offer.show_prices"
                                                       class="masonry-grid-item-info">{{ 'offer.price' | translate:urlService.lang }}
                                                        : <span
                                                            [innerHTML]="work | workPrice:'exhibition_item:price':_exhibition.retail_price_currency:true"></span>
                                                    </p>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'object_availabilty_reservated'">
                                                    <p class="masonry-grid-item-info statusOnOfferList">
                                                        {{ 'offer.reserved' | translate:urlService.lang }}
                                                    </p>
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    <p class="masonry-grid-item-info statusOnOfferList">
                                                        {{ 'offer.sold' | translate:urlService.lang }}
                                                    </p>
                                                </ng-container>
                                            </ng-container>

                                            <p style="display: none">{{_exhibition|json}}</p>
                                            <p style="display: none">{{_exhibition.retail_price_currency}}</p>
                                        </div>
                                    </a>
                                </article>
                            </div>

                        </div>
                    </div>
                </ng-template>


            </div>
        </div>
    </section>
</div>

<!-- blocks: after -->
<app-blocks-wrapper context="exhibition" placement="after"></app-blocks-wrapper>
